var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "#054254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.8125C9.5 12.1125 9.04375 13.2188 8.13125 14.1313C7.21875 15.0438 6.1125 15.5 4.8125 15.5C3.5125 15.5 2.40625 15.0438 1.49375 14.1313C0.58125 13.2188 0.125 12.1125 0.125 10.8125V3.875C0.125 2.9375 0.453125 2.14063 1.10938 1.48438C1.76563 0.828125 2.5625 0.5 3.5 0.5C4.4375 0.5 5.23438 0.828125 5.89062 1.48438C6.54688 2.14063 6.875 2.9375 6.875 3.875V10.4375C6.875 11.0125 6.675 11.5 6.275 11.9C5.875 12.3 5.3875 12.5 4.8125 12.5C4.2375 12.5 3.75 12.3 3.35 11.9C2.95 11.5 2.75 11.0125 2.75 10.4375V3.5H4.25V10.4375C4.25 10.6 4.30313 10.7344 4.40938 10.8406C4.51562 10.9469 4.65 11 4.8125 11C4.975 11 5.10938 10.9469 5.21563 10.8406C5.32188 10.7344 5.375 10.6 5.375 10.4375V3.875C5.3625 3.35 5.17813 2.90625 4.82188 2.54375C4.46563 2.18125 4.025 2 3.5 2C2.975 2 2.53125 2.18125 2.16875 2.54375C1.80625 2.90625 1.625 3.35 1.625 3.875V10.8125C1.6125 11.7 1.91875 12.4531 2.54375 13.0719C3.16875 13.6906 3.925 14 4.8125 14C5.6875 14 6.43125 13.6906 7.04375 13.0719C7.65625 12.4531 7.975 11.7 8 10.8125V3.5H9.5V10.8125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardIcon);
export default __webpack_public_path__ + "static/media/clipboardIcon.c0003fb6f9c3a2e10e7a09f5313de94c.svg";
export { ForwardRef as ReactComponent };